import SosSection from "@/components/SosSection";

export default function SosPage() {
  return <SosSection />;
}
